import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Loader } from '../../../../shared/components/Loader';
import FormBuilder from '../../../../shared/components/FormBuilder';
import { Button } from '../../../../shared/components/button/Button';
import * as Icon from '@mui/icons-material/';
import { ContasReceberSchema } from '../../../../schemas/ContasReceberSchema';
import { useEffect, useState, useRef } from 'react';
import ClienteController from '../../../../controllers/ClienteController';
import CondicaoPagamentoController from '../../../../controllers/CondicaoPagamentoController';
import FormaPagamentoController from '../../../../controllers/FormaPagamentoController';
import ContaReceberController from '../../../../controllers/ContaReceberController';
import * as path from '../../../../routes/RoutesNames';
import { toast } from 'react-toastify';

export default function ContasReceberCadastrar() {
  // const { id } = useParams();
  const navigate = useNavigate();

  // const contaId = id ? parseInt(id, 10) : null;

  const [usuarios, setUsuarios] = useState([]);
  const [condicoesParcelamento, setCondicoesParcelamento] = useState([]);
  const [formasPagamento, setFormasPagamento] = useState([]);

  const fetchUsuarios = async (v) => {
    const response = await ClienteController.ListarVendedor(v);
    if (response.StatusCode === 200) {
      return setUsuarios(response.Data || []);
    }
    setUsuarios([])
  };

  const fetchCondicoesParcelamento = async () => {
    const response = await CondicaoPagamentoController.Listar({ CondicaoPagamentoId: null, Descricao: '', TipoUtilizacao: '', TipoParcelamento: '', Quantidade: '' });

    if (response.StatusCode === 200) {
      const condicoesValidas = (response.Data || []).filter((c: any) => Number(c.cpg_quantidade) > 0);
      return setCondicoesParcelamento(condicoesValidas);
    }
    setCondicoesParcelamento([])
  }

  const fetchFormasPagamento = async () => {
    const response = await FormaPagamentoController.Listar({ FormaPagamentoId: null, Descricao: '', TipoPagamentoId: null, TipoUtilizacao: '', TipoCartao: '', TaxaMinima: null, TaxaTransAVista: null, QntdDiasRecebimento: null });

    if (response.StatusCode === 200) {
      return setFormasPagamento(response.Data || []);
    }
    setFormasPagamento([])
  }

  const fields = [
    { name: 'valor', type: 'number', label: 'Valor', col: 4, required: true },
    { name: 'formas_pagamento', type: 'select', label: 'Formas de pagamento', options: formasPagamento.map((o: any) => ({ value: o.fpg_id, label: o.fpg_descricao })), col: 4, required: true },
    { name: 'cliente', type: 'autocomplete', label: 'Cliente', col: 4, options: usuarios, optionKey: "cli_id", optionLabel: 'cli_nome', required: true, onInput: (_, v: any) => fetchUsuarios(v)},
    {
      name: 'group-1',
      type: 'group',
      col: 8,
      gap: 'gap-3',
      fields: [
        { name: 'lancamento', type: 'date', label: 'Data Lançamento', col: 6, required: true },
        { name: 'vencimento', type: 'date', label: 'Data Vencimento', col: 6, required: true },
        { name: 'bandeira', type: 'select', label: 'Bandeira', col: 6, options: [{ value: 1, label: 'Master Card'}, { value: 2, label: 'Visa' }], required: true },
        { name: 'condicao_parcelamento', type: 'select', label: 'Condição Parcelamento', col: 6, options: condicoesParcelamento.map((o: any) => ({ value: o.cpg_id, label: o.cpg_descricao })), required: true },
      ]
    },
    {
      name: 'group-2',
      type: 'group',
      col: 4,
      fields: [
        { name: 'descricao', type: 'text', label: 'Descrição', col: 12, multiline: true, rows: 4 },
      ]
    }
  ]

  const loading = false

  const handleSubmit = async (req: any) => {
    const response = await ContaReceberController.Inserir({
      // ...req,
      vencimento: req.vencimento,
      ban_id: req.bandeira,
      cpg_id: req.condicao_parcelamento,
      cli_id: req.cliente?.cli_id,
      descricao: req.descricao,
      valor: req.valor
    })
    if (response.StatusCode >= 200 && response.StatusCode < 300) {
      toast('Parcela(as) cadastrada(s) com sucesso!', {
        type: 'success',
      });
      return navigate(path.ContasReceber);
    }
    toast('Erro ao cadastrar parcela(as)!', { type: 'error' });
  }

  const initialValues = {
    ...fields.filter(f => !!f.name).map(f => f.fields || f).flat().reduce((o, f) => ({ ...o, [f.name as string]: '' }), {})
  }

  useEffect(() => {
    fetchCondicoesParcelamento()
    fetchFormasPagamento()
  }, [])

  const formRef = useRef(null);
  
  return (
    <Loader loading={loading}>
      <Box>
        <HeaderComponent text={'Cadastro de Contas Receber'}
          ButtonRight={
            <Button
              className={''}
              variant='success'
              onClick={() => { formRef.current.submitForm(); }}
              iconStart={<Icon.Save />}
              title={'Salvar'}
            />
          }
        />
        <FormBuilder innerRef={formRef} fields={fields} initialValues={initialValues} validationSchema={ContasReceberSchema} onSubmit={handleSubmit} gap='gap-3' />
      </Box>
    </Loader>
  );
}
